export const comments_4322232 = {"data":{"data":[],"links":{}}}